import { BaseProvider } from '@telus-uds/components-web';
import alliumTheme from '@telus-uds/theme-allium';
import '@telus-uds/palette-allium/build/web/fonts/fonts-cdn.css';
import React from 'react';

import LocaleContextProvider from './components/context/LocaleContext';
import LocalizedStringsContextProvider from './components/context/LocalizedStringsContext';

import Routes from './components/routes';
import SessionTimeout from './components/design/session-timeout';

const App = () => {
  return (
    <BaseProvider defaultTheme={alliumTheme}>
    <LocaleContextProvider>
      <LocalizedStringsContextProvider>
        <SessionTimeout>
          <Routes />
        </SessionTimeout>
      </LocalizedStringsContextProvider>
    </LocaleContextProvider>
    </BaseProvider>
  );
};

export default App;
 